import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { dates } from "@/lib/dates";
import { CalendarAndTasksData, HttpResponse, Task, TaskType } from "@/types";

export function useUpdateSetDashboardTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      ...changes
    }: {
      id: number;
      completedDate?: string | null;
      dueDate?: string;
    }) => {
      const path = `tasks/${id.toString()}`;
      const res = await guacHttpClient.patch<Task, HttpResponse<Task>>(
        path,
        changes,
      );

      return res.data;
    },
    onSuccess: (_task, { id, ...changes }) => {
      queryClient.setQueriesData<CalendarAndTasksData>(
        { queryKey: ["calendar-and-tasks"] },
        (cachedData) => {
          if (!cachedData) return cachedData;
          return {
            ...cachedData,
            tasks: cachedData.tasks.flatMap((task) => {
              if (task.id !== id) return [task];
              const updated = { ...task, ...changes };
              // A missing-start pushed to a future date is postponed — the BE
              // drops it from the window, so drop it here too.
              const isFutureMissingStart =
                updated.type === TaskType.MISSING_START_DATE &&
                updated.dueDate != null &&
                dates.taskDueDate(updated.dueDate) >=
                  dates.addLocalDays(new Date(), 1);
              return isFutureMissingStart ? [] : [updated];
            }),
          };
        },
      );
    },
  });
}
